/*
 * Ryan O'Dowd
 * 2025-05-23
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors, isDarkMode}) => {
  return {
    sectionTitle: { // @TODO: in the dialog...could probably be in commonStyles // @TODO: duplicated in other widgets...move to widgetbase?
      marginTop: globalScale * 16,
      fontSize: globalScale * 16,
      fontFamily: fonts.secondaryBold,
      color: isDarkMode ? colors.white : colors.black,
    },
    sectionWrapper: { // @TODO: in the dialog...could probably be in commonStyles // @TODO: duplicated in other widgets...move to widgetbase?
      padding: 8,
      paddingTop: 0,
    },
    forecastContentWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 8,
      minHeight: '100%',
      padding: 4,
    },
    forecastText: {
      alignSelf: 'center',
      justifyContent: 'center',
      fontSize: globalScale * 16,
      color: colors.white,
    },
    switches: {
      display: 'flex',
      marginTop: globalScale * 16,
      gap: 4,
    },
    switchWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    progressWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      gap: 4,
      padding: 4,
    },
  };
};

export default getStyles;
